import { ax } from 'src/client'
import { GET_ACCOUNTS_URL, GET_ACCOUNT_STATEMENTS_URL } from './serviceURLS'

export const getAccountStatements = (accountId, params) => {
  return ax.get(GET_ACCOUNT_STATEMENTS_URL.replace(':id', accountId), {
    params
  })
}

export const getAccounts = (companyId) => {
  return ax.get(GET_ACCOUNTS_URL, { params: { owner_id: companyId } })
}
